import React from 'react';
import { MantineProvider } from '@mantine/core';

import type { TicketsMantineProviderTypes } from './TicketsMantineProvider.types';

/**
 * TicketsMantineProvider
 * @author ondrejvseticka <ondravseticka@email.cz>
 * @constructor
 */
export const TicketsMantineProvider = ({ theme, children }: TicketsMantineProviderTypes.Props) => {
	return <MantineProvider theme={theme}>{children}</MantineProvider>;
};

/** TicketsMantineProvider component display name */
TicketsMantineProvider.displayName = 'TicketsMantineProvider';
